import { http } from "@/http";

export default {
  list(params) {
    return http.get("/api/v1/admin/biolink/config", { params });
  },
  save(payload) {
    return http.put("/api/v1/admin/biolink/config", payload);
  }
};